import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const BreadCrumbContext = createContext(defaultState);

export default BreadCrumbContext;
